module.exports = "/static/assets/80273036af50141f12d92825bda428cb.png";